var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 50 50"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "location_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.5,
  d: "M0 0h19.131v22.279H0z",
  "data-name": "Rectangle 6976"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19633"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M25 0A25 25 0 1 1 0 25 25 25 0 0 1 25 0",
  "data-name": "Path 27389"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19459"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#location_svg__a)",
  "data-name": "Group 19458",
  transform: "translate(15.435 13.859)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M11.817 9.566a2.25 2.25 0 1 1-2.251-2.249 2.25 2.25 0 0 1 2.251 2.249m6.215 0c0 3.11-3.747 7.819-6.255 10.622a2.96 2.96 0 0 1-4.42 0c-2.509-2.803-6.256-7.512-6.256-10.622a8.465 8.465 0 1 1 16.93 0Z",
  "data-name": "Path 27327"
}))))));
export { SvgLocation as ReactComponent };
export default __webpack_public_path__ + "static/media/location.92c3c3a84b8510dba920ee82ec37ac4c.svg";